// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { config } from "../../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../../redux/actions";
import { InputLabel } from "@material-ui/core";
import "../localreporting.scss";
import Loader from "../../../../components/Loader/Loader";
import FileUpload from "../../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../../utils/utils";
import Popover from "@mui/material/Popover";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    updateSourceInputs,
    isFileUploading,
    loading,
    setMappedData,
    updateAlert,
    isPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isCountryLoading, setIsCountryLoading] = useState(false);
  const [isHarborFileIdLoading, setIsHarborFileIdLoading] = useState(false);
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();
  const { login } = useUserAuthentication();

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  const isCreateNewVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Create new" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return source_data.current_source == "";
  }, [source_data, source_data.current_filter_value]);

  const isExistingVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Existing" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return source_data.current_source == "";
  }, [source_data, source_data.current_filter_value]);

  // FETCH META DATA FOR SELECTED DATASET
  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");

    // API call to get Updated SFF_File_Id based on Filter
    const params = new URLSearchParams({
      usecase_name: Use_Case_Name || "",
      source: selectedOption.value || "",
    });

    try {
      const response = await fetch(
        api + `/local_reporting/getcountries?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const COUNTRIES = data.data || [];

      const FINAL_COUNTRIES =
        COUNTRIES?.filter(
          (country) =>
            country !== null && country !== undefined && country !== "",
        )?.map((item) => {
          return { label: item, value: item };
        }) ?? [];

      updateSourceInputs("current_mapped_country", FINAL_COUNTRIES);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }
  };

  // FETCH COUNTRIES FOR CHOSEN FILTER TYPE
  const handleRadioChange = async (e) => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_filter_value", e.target.value);
    updateSourceInputs("current_mapping_type", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);
  };

  // FETCH COUNTRIES FOR SELECTED MAPPING_TYPE
  const handleMappingTypeChange = async (e, selectedOption) => {
    setIsCountryLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapping_type", selectedOption);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isAnyRecordDeleted", false);

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        source: source_data?.current_source || "",
        mapping_type: selectedOption?.value || "",
        filtertype:
          source_data?.current_filter_value?.toLowerCase() === "create new"
            ? "create"
            : "existing" || "",
      });

      const response = await fetch(
        api + `/local_reporting/attribute_mapping/getcountries?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return false;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const COUNTRIES = data?.data || [];
      const FINAL_COUNTRIES =
        COUNTRIES?.filter(
          (country) =>
            country !== null && country !== undefined && country !== "",
        )?.map((item) => {
          return { label: item, value: item };
        }) ?? [];
      updateSourceInputs("current_mapped_country", FINAL_COUNTRIES);
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }
    setIsCountryLoading(false);
  };

  // FETCH SFF_FILE_ID'S FOR SELECTED COUNTRY
  const handleCountryChange = async (e, selectedOption) => {
    setIsHarborFileIdLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_country_code", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("current_iqvia_source_file_id", []);
    updateSourceInputs("current_nielsen_source_file_id_list", []);
    updateSourceInputs("current_iqvia_source_file_id", "");
    updateSourceInputs("current_nielsen_source_file_id", "");

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        source: source_data?.current_source || "",
        country_code: selectedOption?.value || "",
        mapping_type: source_data?.current_mapping_type?.label || "",
      });

      const response = await fetch(
        api + `/local_reporting/attribute_mapping/getfileid?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return false;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const IQVIA_LIST = data?.data?.IQVIA_HARBOR_SOURCE_FILE_ID || [];
      const NIELSEN_LIST = data?.data?.NIELSEN_HARBOR_SOURCE_FILE_ID || [];
      const SORTED_IQVIA_LIST =
        IQVIA_LIST?.map((item) => {
          return { label: item, value: item };
        }) ?? [];
      const SORTED_NIELSEN_LIST =
        NIELSEN_LIST?.map((item) => {
          return { label: item, value: item };
        }) ?? [];
      updateSourceInputs(
        "current_iqvia_source_file_id_list",
        SORTED_IQVIA_LIST,
      );
      updateSourceInputs(
        "current_nielsen_source_file_id_list",
        SORTED_NIELSEN_LIST,
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsHarborFileIdLoading(false);
  };

  const handleIqviaSourceFileIdChange = (e, selectedOption) => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("current_nielsen_source_file_id", "");

    updateSourceInputs("current_iqvia_source_file_id", selectedOption);
  };

  const handleNielsenSourceFileIdChange = (e, selectedOption) => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("current_nielsen_source_file_id", selectedOption);

    // API call to fetch Table Data
    setMappedData(
      Use_Case_Name || "",
      source_data?.current_source || "",
      source_data?.current_country_code || "",
      source_data?.current_mapping_type?.label || "",
      source_data?.current_mapping_type?.value || "",
      source_data?.current_iqvia_source_file_id?.value || "",
      selectedOption?.value || "",
    );
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr)", // 5 equal-width columns
              gridTemplateRows: "1fr", // 1 row
              gap: "12px", // gap between columns (and rows if any)
              padding: "2px 15px 0px 15px",
              width: "100%",
            }}
          >
            <>
              {/* DATASETS */}
              <div item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Source:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disabled={true}
                    disableClearable
                    size="small"
                    options={source_data?.current_mapped_source || []}
                    loading={
                      loading &&
                      (source_data.current_mapped_source ||
                        source_data.current_mapped_source.length === 0)
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSourceChange}
                    value={
                      // source_data.current_source &&
                      // source_data.current_source.length > 0
                      //   ? {
                      //       label: source_data.current_source,
                      //       value: source_data.current_source,
                      //     }
                      //   : null
                      {
                        label: "IQVIA",
                        value: "IQVIA",
                      }
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          // color:
                          //   source_data.current_source === "" ||
                          //   source_data.data.dropdown.SOURCE.is_disabled
                          //     ? "f7f7f7"
                          //     : "#555",
                          color: "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        // backgroundColor: source_data.data.dropdown.SOURCE
                        //   .is_disabled
                        //   ? "#d6d6d6"
                        //   : "#fff",
                        backgroundColor: "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* FILTERS - CREATE NEW OR EXISTING */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Choose Filter:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div
                  className="radio-input-container"
                  style={{ marginBottom: "15px" }}
                >
                  {/* Insert New */}
                  <div className="radio-input-div">
                    <input
                      id="all-checkbox"
                      type="radio"
                      value="Create new"
                      disabled={isCreateNewVisible ? true : false}
                      name="filter"
                      checked={
                        source_data.current_filter_value === "Create new"
                      }
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"all-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Create new
                    </InputLabel>
                  </div>

                  {/* Existing */}
                  <div className="radio-input-div">
                    <input
                      id="Unmapped-checkbox"
                      type="radio"
                      value="Existing"
                      disabled={isExistingVisible ? true : false}
                      name="filter"
                      checked={source_data.current_filter_value === "Existing"}
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"Unmapped-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Existing
                    </InputLabel>
                  </div>
                </div>
              </div>

              {/* MAPPING TYPE */}
              <div item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Mapping Type:
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    disabled={
                      !source_data.current_filter_value ||
                      source_data.current_filter_value.length === 0
                    }
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data?.data?.dropdown?.MAPPING_TYPE || []}
                    getOptionLabel={(option) => option.label}
                    onChange={handleMappingTypeChange}
                    value={source_data?.current_mapping_type || null}
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_filter_value === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_filter_value === ""
                            ? "#d6d6d6"
                            : "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* COUNTRY */}
              <div item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Country Code:
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    disabled={
                      !source_data.current_mapping_type ||
                      source_data.current_mapping_type.length === 0
                    }
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data.current_mapped_country}
                    loading={isCountryLoading}
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleCountryChange}
                    value={
                      {
                        label: source_data.current_country,
                        value: source_data.current_country_code,
                      } || null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_mapping_type === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_mapping_type === ""
                            ? "#d6d6d6"
                            : "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* IQVIA SOURCE FILE ID */}
              <div item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Iqvia Source File Id:
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    disabled={
                      !source_data.current_country_code ||
                      source_data.current_country_code.length === 0
                    }
                    id="country-select"
                    disableClearable
                    size="small"
                    options={
                      source_data?.current_iqvia_source_file_id_list || []
                    }
                    loading={isHarborFileIdLoading}
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleIqviaSourceFileIdChange}
                    value={source_data?.current_iqvia_source_file_id || null}
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_country_code === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_country_code === ""
                            ? "#d6d6d6"
                            : "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* NIELSEN SOURCE FILE ID */}
              <div item xs={3} sm={3}>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Nielsen Source File Id:
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    disabled={
                      !source_data.current_iqvia_source_file_id ||
                      source_data.current_iqvia_source_file_id.length === 0
                    }
                    id="country-select"
                    disableClearable
                    size="small"
                    options={
                      source_data?.current_nielsen_source_file_id_list || []
                    }
                    // loading={isCountryLoading}
                    // loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleNielsenSourceFileIdChange}
                    value={source_data.current_nielsen_source_file_id || null}
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_iqvia_source_file_id === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_iqvia_source_file_id === ""
                            ? "#d6d6d6"
                            : "#fff",
                        fontFamily: "Hind Siliguri",
                        borderRadius: "6px",
                        fontSize: "13px",
                        fontWeight: "400",
                        color: "#333",
                        height: "36px",
                        paddingRight: "36px", // space for dropdown icon
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiAutocomplete-endAdornment": {
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)", // vertical center alignment
                      },
                      "& .MuiSvgIcon-root": {
                        color: "#999",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter),
);
